import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiFileText } = FiIcons;

const CGU = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-[#004d44]">
      <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md shadow-sm py-4">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <a href="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-lg bg-[#00a48c] text-white flex items-center justify-center font-black">S</div>
            <span className="text-xl font-black tracking-tight">Simulation Rendement PER</span>
          </a>
          <a href="/" className="flex items-center gap-2 text-sm font-bold text-[#00a48c] hover:underline">
            <SafeIcon icon={FiArrowLeft} /> Retour à l'accueil
          </a>
        </div>
      </nav>

      <main className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-2xl bg-[#f0fcf9] text-[#00a48c] flex items-center justify-center text-2xl">
                <SafeIcon icon={FiFileText} />
              </div>
              <h1 className="text-4xl font-black uppercase tracking-tight">Conditions Générales d'Utilisation</h1>
            </div>

            <div className="prose prose-slate max-w-none space-y-8 text-gray-600 font-medium leading-relaxed">
              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">1. Objet du simulateur</h2>
                <p>Le simulateur présent sur ce site est un outil d'estimation. Les résultats produits sont donnés à titre indicatif et ne constituent en aucun cas un engagement contractuel ou un conseil personnalisé définitif.</p>
              </section>

              <section className="bg-[#f0fcf9]/30 p-8 rounded-[2rem] border border-[#f0fcf9]">
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">2. Responsabilité</h2>
                <p>Le Groupe Vaillance Conseil ne saurait être tenu responsable des conséquences d'une interprétation erronée des résultats de la simulation par l'utilisateur. Tout investissement financier comporte des risques, notamment de perte en capital.</p>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">3. Accès au service</h2>
                <p>Le site est accessible gratuitement à tout utilisateur disposant d'un accès à internet. Tous les coûts afférents à l'accès au service sont à la charge de l'utilisateur.</p>
              </section>

              <section>
                <h2 className="text-xl font-black text-[#004d44] mb-4 uppercase">4. Propriété intellectuelle</h2>
                <p>Tous les éléments du site (textes, graphismes, logos, simulateur) sont la propriété exclusive du Groupe Vaillance Conseil. Toute reproduction est interdite sans accord préalable.</p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CGU;